const CustomerBasicInfo = () => import('@/views/main/wechatMgmt/customerBasicInfo/CustomerBasicInfo.vue')
export default {
  path: '/main/wechatMgmt/customerBasicInfo',
  name: 'customerBasicInfo',
  component: CustomerBasicInfo
}
